module.exports = __webpack_public_path__ + "media/images/countrysquared/ng-1770cc7e58bf71710f6eb59b919b3cf2.svg";